import { Injectable } from '@angular/core';
import { User } from '../domain/model/user';
import { UserInfo } from '../domain/model/user-info';

@Injectable({
  providedIn: 'root',
})

// TO DO: Add user info from http context
export class UserService {
  constructor() {}

  getUser(): User {
    return {
      userId: 'testuserId',
    };
  }

  getUserInfo(): UserInfo {
    return new UserInfo('testeruserid', 'testusername');
  }
}
